import { render, staticRenderFns } from "./addQuestionBank.vue?vue&type=template&id=4ae8a5bc"
import script from "./addQuestionBank.vue?vue&type=script&lang=js"
export * from "./addQuestionBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports